import { useEffect } from "react";

export const readListState = (storageKey) => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveListState = (storageKey, state) => {
  sessionStorage.setItem(storageKey, JSON.stringify(state));
};

export const clearListState = (storageKey) => {
  sessionStorage.removeItem(storageKey);
};

export const LIST_STATE_FLOWS = {
  accounts: { list: "/accounts", detailPrefix: "/accounts" },
  deals: { list: "/deals", detailPrefix: "/deals" },
  inventory: { list: "/search-inventory", detailPrefix: "/inventory" },
  customers: { list: "/customers", detailPrefix: "/customers" },
  users: { list: "/users", detailPrefix: "/users" },
};

export const isListFlowPath = (flow, pathname) => {
  if (pathname === flow.list) return true;
  if (!flow.detailPrefix) return false;
  const escaped = flow.detailPrefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return new RegExp(`^${escaped}/[^/]+$`).test(pathname);
};

/**
 * Liste veya detaydan çıkınca state'i sil — yalnızca aynı modül içinde
 * (liste ↔ detay) kalınıyorsa koru.
 */
export const useClearListStateOnLeave = (storageKey, flow, { enabled = true } = {}) => {
  useEffect(() => {
    if (!enabled) return undefined;
    return () => {
      if (!isListFlowPath(flow, window.location.pathname)) {
        clearListState(storageKey);
      }
    };
  }, [storageKey, flow, enabled]);
};
